import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cbd4fa14 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _1c4468ea = () => interopDefault(import('../../../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _629398e5 = () => interopDefault(import('../../../pages/balance/index.vue' /* webpackChunkName: "pages/balance/index" */))
const _b2d66cfc = () => interopDefault(import('../../../pages/charts/index.vue' /* webpackChunkName: "pages/charts/index" */))
const _5fe77fe2 = () => interopDefault(import('../../../pages/claim-anchored-bottles.vue' /* webpackChunkName: "pages/claim-anchored-bottles" */))
const _5e344f55 = () => interopDefault(import('../../../pages/confirm-email.vue' /* webpackChunkName: "pages/confirm-email" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0c3cbe3d = () => interopDefault(import('../../../pages/investor-portfolio.vue' /* webpackChunkName: "pages/investor-portfolio" */))
const _64868cf8 = () => interopDefault(import('../../../pages/lessons/index.vue' /* webpackChunkName: "pages/lessons/index" */))
const _10ba8d22 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _59bdffc1 = () => interopDefault(import('../../../pages/order-confirmation/index.vue' /* webpackChunkName: "pages/order-confirmation/index" */))
const _d4beb662 = () => interopDefault(import('../../../pages/orders.vue' /* webpackChunkName: "pages/orders" */))
const _358c1412 = () => interopDefault(import('../../../pages/orders/index.vue' /* webpackChunkName: "pages/orders/index" */))
const _56a5075c = () => interopDefault(import('../../../pages/orders/columns.js' /* webpackChunkName: "pages/orders/columns" */))
const _14cad918 = () => interopDefault(import('../../../pages/orders/filters.js' /* webpackChunkName: "pages/orders/filters" */))
const _7813be64 = () => interopDefault(import('../../../pages/portfolio.vue' /* webpackChunkName: "pages/portfolio" */))
const _4023565e = () => interopDefault(import('../../../pages/portfolio/index.vue' /* webpackChunkName: "pages/portfolio/index" */))
const _92c046ac = () => interopDefault(import('../../../pages/portfolio/bids/index.vue' /* webpackChunkName: "pages/portfolio/bids/index" */))
const _4da7fac6 = () => interopDefault(import('../../../pages/portfolio/claimed/index.vue' /* webpackChunkName: "pages/portfolio/claimed/index" */))
const _61c6868a = () => interopDefault(import('../../../pages/portfolio/current/index.vue' /* webpackChunkName: "pages/portfolio/current/index" */))
const _af222ef0 = () => interopDefault(import('../../../pages/portfolio/onboarded/index.vue' /* webpackChunkName: "pages/portfolio/onboarded/index" */))
const _5cd9ce30 = () => interopDefault(import('../../../pages/portfolio/sold/index.vue' /* webpackChunkName: "pages/portfolio/sold/index" */))
const _7612c6ba = () => interopDefault(import('../../../pages/portfolio/bids/columns.js' /* webpackChunkName: "pages/portfolio/bids/columns" */))
const _b5e941b2 = () => interopDefault(import('../../../pages/portfolio/claimed/columns.js' /* webpackChunkName: "pages/portfolio/claimed/columns" */))
const _6d31e8c9 = () => interopDefault(import('../../../pages/portfolio/current/columns.js' /* webpackChunkName: "pages/portfolio/current/columns" */))
const _e3c2002a = () => interopDefault(import('../../../pages/portfolio/current/filters.js' /* webpackChunkName: "pages/portfolio/current/filters" */))
const _83b592c8 = () => interopDefault(import('../../../pages/portfolio/onboarded/columns.js' /* webpackChunkName: "pages/portfolio/onboarded/columns" */))
const _8cf1db88 = () => interopDefault(import('../../../pages/portfolio/sold/columns.js' /* webpackChunkName: "pages/portfolio/sold/columns" */))
const _41d65b66 = () => interopDefault(import('../../../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _6cfe81d6 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _2b00fc21 = () => interopDefault(import('../../../pages/select-portfolio.vue' /* webpackChunkName: "pages/select-portfolio" */))
const _f6ff91d4 = () => interopDefault(import('../../../pages/signin-callback.vue' /* webpackChunkName: "pages/signin-callback" */))
const _811604b0 = () => interopDefault(import('../../../pages/terms-conditions.vue' /* webpackChunkName: "pages/terms-conditions" */))
const _20f4496f = () => interopDefault(import('../../../pages/whisky-catalogue.vue' /* webpackChunkName: "pages/whisky-catalogue" */))
const _42c31f6a = () => interopDefault(import('../../../pages/whisky-catalogue/_slug.vue' /* webpackChunkName: "pages/whisky-catalogue/_slug" */))
const _af77a86e = () => interopDefault(import('../../../pages/whisky-catalogue-old.vue' /* webpackChunkName: "pages/whisky-catalogue-old" */))
const _42599966 = () => interopDefault(import('../../../pages/workshops-and-webinars/index.vue' /* webpackChunkName: "pages/workshops-and-webinars/index" */))
const _7f4a555f = () => interopDefault(import('../../../pages/account/documents/index.vue' /* webpackChunkName: "pages/account/documents/index" */))
const _47948b62 = () => interopDefault(import('../../../pages/account/personal/index.vue' /* webpackChunkName: "pages/account/personal/index" */))
const _489691df = () => interopDefault(import('../../../pages/balance/columns.js' /* webpackChunkName: "pages/balance/columns" */))
const _6983a901 = () => interopDefault(import('../../../pages/balance/filters.js' /* webpackChunkName: "pages/balance/filters" */))
const _24354519 = () => interopDefault(import('../../../pages/category/columns.js' /* webpackChunkName: "pages/category/columns" */))
const _45225c3b = () => interopDefault(import('../../../pages/category/filters.js' /* webpackChunkName: "pages/category/filters" */))
const _c7575bdc = () => interopDefault(import('../../../pages/category/sorting.js' /* webpackChunkName: "pages/category/sorting" */))
const _f6eca36a = () => interopDefault(import('../../../pages/registration/confirm-your-email.vue' /* webpackChunkName: "pages/registration/confirm-your-email" */))
const _13afa42f = () => interopDefault(import('../../../pages/registration/finish.vue' /* webpackChunkName: "pages/registration/finish" */))
const _19e4a214 = () => interopDefault(import('../../../pages/registration/start.vue' /* webpackChunkName: "pages/registration/start" */))
const _1a9ca4f9 = () => interopDefault(import('../../../pages/registration/start/index.vue' /* webpackChunkName: "pages/registration/start/index" */))
const _fa5f614a = () => interopDefault(import('../../../pages/registration/start/address.vue' /* webpackChunkName: "pages/registration/start/address" */))
const _4e71acf6 = () => interopDefault(import('../../../pages/registration/start/confirm-email.vue' /* webpackChunkName: "pages/registration/start/confirm-email" */))
const _a2140e7c = () => interopDefault(import('../../../pages/registration/start/personal-info.vue' /* webpackChunkName: "pages/registration/start/personal-info" */))
const _5724174e = () => interopDefault(import('../../../pages/account/claim-list/confirmation.vue' /* webpackChunkName: "pages/account/claim-list/confirmation" */))
const _0ff7a7e1 = () => interopDefault(import('../../../pages/account/claim-list/index/index.vue' /* webpackChunkName: "pages/account/claim-list/index/index" */))
const _7a9136b6 = () => interopDefault(import('../../../pages/account/documents/columns.js' /* webpackChunkName: "pages/account/documents/columns" */))
const _47b46263 = () => interopDefault(import('../../../pages/account/claim-list/index/columns.js' /* webpackChunkName: "pages/account/claim-list/index/columns" */))
const _68a17985 = () => interopDefault(import('../../../pages/account/claim-list/index/filters.js' /* webpackChunkName: "pages/account/claim-list/index/filters" */))
const _7d93b417 = () => interopDefault(import('../../../pages/account/documents/_slug.vue' /* webpackChunkName: "pages/account/documents/_slug" */))
const _1b1b066d = () => interopDefault(import('../../../pages/whisky/basket/_slug.vue' /* webpackChunkName: "pages/whisky/basket/_slug" */))
const _1a8dc7a2 = () => interopDefault(import('../../../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _155df523 = () => interopDefault(import('../../../pages/category/_slug.vue' /* webpackChunkName: "pages/category/_slug" */))
const _67f3cf88 = () => interopDefault(import('../../../pages/lessons/_slug.vue' /* webpackChunkName: "pages/lessons/_slug" */))
const _d0c7f55e = () => interopDefault(import('../../../pages/whisky/_slug/index.vue' /* webpackChunkName: "pages/whisky/_slug/index" */))
const _45c6dbf6 = () => interopDefault(import('../../../pages/workshops-and-webinars/_slug.vue' /* webpackChunkName: "pages/workshops-and-webinars/_slug" */))
const _3fa852ae = () => interopDefault(import('../../../pages/whisky/_slug/transactions/index.vue' /* webpackChunkName: "pages/whisky/_slug/transactions/index" */))
const _7e060c9b = () => interopDefault(import('../../../pages/whisky/_slug/transactions/columns.js' /* webpackChunkName: "pages/whisky/_slug/transactions/columns" */))
const _f6ee20da = () => interopDefault(import('../../../pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))
const _1374b544 = () => interopDefault(import('../../../pages/_slug/_seoArticleSlug.vue' /* webpackChunkName: "pages/_slug/_seoArticleSlug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _cbd4fa14,
    name: "account"
  }, {
    path: "/articles",
    component: _1c4468ea,
    name: "articles"
  }, {
    path: "/balance",
    component: _629398e5,
    name: "balance"
  }, {
    path: "/charts",
    component: _b2d66cfc,
    name: "charts"
  }, {
    path: "/claim-anchored-bottles",
    component: _5fe77fe2,
    name: "claim-anchored-bottles"
  }, {
    path: "/confirm-email",
    component: _5e344f55,
    name: "confirm-email"
  }, {
    path: "/en",
    component: _2dfb1658,
    name: "index___en"
  }, {
    path: "/investor-portfolio",
    component: _0c3cbe3d,
    name: "investor-portfolio"
  }, {
    path: "/lessons",
    component: _64868cf8,
    name: "lessons"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/nl",
    component: _2dfb1658,
    name: "index___nl"
  }, {
    path: "/order-confirmation",
    component: _59bdffc1,
    name: "order-confirmation"
  }, {
    path: "/orders",
    component: _d4beb662,
    children: [{
      path: "",
      component: _358c1412,
      name: "orders"
    }, {
      path: "columns",
      component: _56a5075c,
      name: "orders-columns"
    }, {
      path: "filters",
      component: _14cad918,
      name: "orders-filters"
    }]
  }, {
    path: "/portfolio",
    component: _7813be64,
    children: [{
      path: "",
      component: _4023565e,
      name: "portfolio"
    }, {
      path: "bids",
      component: _92c046ac,
      name: "portfolio-bids"
    }, {
      path: "claimed",
      component: _4da7fac6,
      name: "portfolio-claimed"
    }, {
      path: "current",
      component: _61c6868a,
      name: "portfolio-current"
    }, {
      path: "onboarded",
      component: _af222ef0,
      name: "portfolio-onboarded"
    }, {
      path: "sold",
      component: _5cd9ce30,
      name: "portfolio-sold"
    }, {
      path: "bids/columns",
      component: _7612c6ba,
      name: "portfolio-bids-columns"
    }, {
      path: "claimed/columns",
      component: _b5e941b2,
      name: "portfolio-claimed-columns"
    }, {
      path: "current/columns",
      component: _6d31e8c9,
      name: "portfolio-current-columns"
    }, {
      path: "current/filters",
      component: _e3c2002a,
      name: "portfolio-current-filters"
    }, {
      path: "onboarded/columns",
      component: _83b592c8,
      name: "portfolio-onboarded-columns"
    }, {
      path: "sold/columns",
      component: _8cf1db88,
      name: "portfolio-sold-columns"
    }]
  }, {
    path: "/registration",
    component: _41d65b66,
    name: "registration"
  }, {
    path: "/search",
    component: _6cfe81d6,
    name: "search"
  }, {
    path: "/select-portfolio",
    component: _2b00fc21,
    name: "select-portfolio"
  }, {
    path: "/signin-callback",
    component: _f6ff91d4,
    name: "signin-callback"
  }, {
    path: "/terms-conditions",
    component: _811604b0,
    name: "terms-conditions"
  }, {
    path: "/whisky-catalogue",
    component: _20f4496f,
    name: "whisky-catalogue",
    children: [{
      path: ":slug?",
      component: _42c31f6a,
      name: "whisky-catalogue-slug"
    }]
  }, {
    path: "/whisky-catalogue-old",
    component: _af77a86e,
    name: "whisky-catalogue-old"
  }, {
    path: "/workshops-and-webinars",
    component: _42599966,
    name: "workshops-and-webinars"
  }, {
    path: "/account/documents",
    component: _7f4a555f,
    name: "account-documents"
  }, {
    path: "/account/personal",
    component: _47948b62,
    name: "account-personal"
  }, {
    path: "/balance/columns",
    component: _489691df,
    name: "balance-columns"
  }, {
    path: "/balance/filters",
    component: _6983a901,
    name: "balance-filters"
  }, {
    path: "/category/columns",
    component: _24354519,
    name: "category-columns"
  }, {
    path: "/category/filters",
    component: _45225c3b,
    name: "category-filters"
  }, {
    path: "/category/sorting",
    component: _c7575bdc,
    name: "category-sorting"
  }, {
    path: "/en/account",
    component: _cbd4fa14,
    name: "account___en"
  }, {
    path: "/en/articles",
    component: _1c4468ea,
    name: "articles___en"
  }, {
    path: "/en/balance",
    component: _629398e5,
    name: "balance___en"
  }, {
    path: "/en/charts",
    component: _b2d66cfc,
    name: "charts___en"
  }, {
    path: "/en/claim-anchored-bottles",
    component: _5fe77fe2,
    name: "claim-anchored-bottles___en"
  }, {
    path: "/en/confirm-email",
    component: _5e344f55,
    name: "confirm-email___en"
  }, {
    path: "/en/investor-portfolio",
    component: _0c3cbe3d,
    name: "investor-portfolio___en"
  }, {
    path: "/en/lessons",
    component: _64868cf8,
    name: "lessons___en"
  }, {
    path: "/en/login",
    component: _10ba8d22,
    name: "login___en"
  }, {
    path: "/en/order-confirmation",
    component: _59bdffc1,
    name: "order-confirmation___en"
  }, {
    path: "/en/orders",
    component: _d4beb662,
    children: [{
      path: "",
      component: _358c1412,
      name: "orders"
    }, {
      path: "columns",
      component: _56a5075c,
      name: "orders-columns___en"
    }, {
      path: "filters",
      component: _14cad918,
      name: "orders-filters___en"
    }, {
      path: "/en/orders",
      component: _358c1412,
      name: "orders___en"
    }]
  }, {
    path: "/en/portfolio",
    component: _7813be64,
    children: [{
      path: "",
      component: _4023565e,
      name: "portfolio___en"
    }, {
      path: "bids",
      component: _92c046ac,
      name: "portfolio-bids"
    }, {
      path: "claimed",
      component: _4da7fac6,
      name: "portfolio-claimed"
    }, {
      path: "current",
      component: _61c6868a,
      name: "portfolio-current"
    }, {
      path: "onboarded",
      component: _af222ef0,
      name: "portfolio-onboarded"
    }, {
      path: "sold",
      component: _5cd9ce30,
      name: "portfolio-sold"
    }, {
      path: "bids/columns",
      component: _7612c6ba,
      name: "portfolio-bids-columns___en"
    }, {
      path: "claimed/columns",
      component: _b5e941b2,
      name: "portfolio-claimed-columns___en"
    }, {
      path: "current/columns",
      component: _6d31e8c9,
      name: "portfolio-current-columns___en"
    }, {
      path: "current/filters",
      component: _e3c2002a,
      name: "portfolio-current-filters___en"
    }, {
      path: "onboarded/columns",
      component: _83b592c8,
      name: "portfolio-onboarded-columns___en"
    }, {
      path: "sold/columns",
      component: _8cf1db88,
      name: "portfolio-sold-columns___en"
    }, {
      path: "/en/portfolio/bids",
      component: _92c046ac,
      name: "portfolio-bids___en"
    }, {
      path: "/en/portfolio/claimed",
      component: _4da7fac6,
      name: "portfolio-claimed___en"
    }, {
      path: "/en/portfolio/current",
      component: _61c6868a,
      name: "portfolio-current___en"
    }, {
      path: "/en/portfolio/onboarded",
      component: _af222ef0,
      name: "portfolio-onboarded___en"
    }, {
      path: "/en/portfolio/sold",
      component: _5cd9ce30,
      name: "portfolio-sold___en"
    }]
  }, {
    path: "/en/registration",
    component: _41d65b66,
    name: "registration___en"
  }, {
    path: "/en/search",
    component: _6cfe81d6,
    name: "search___en"
  }, {
    path: "/en/select-portfolio",
    component: _2b00fc21,
    name: "select-portfolio___en"
  }, {
    path: "/en/signin-callback",
    component: _f6ff91d4,
    name: "signin-callback___en"
  }, {
    path: "/en/terms-conditions",
    component: _811604b0,
    name: "terms-conditions___en"
  }, {
    path: "/en/whisky-catalogue",
    component: _20f4496f,
    name: "whisky-catalogue___en",
    children: [{
      path: "/en/whisky-catalogue/:slug",
      component: _42c31f6a,
      name: "whisky-catalogue-slug___en"
    }, {
      path: ":slug?",
      component: _42c31f6a,
      name: "whisky-catalogue-slug"
    }]
  }, {
    path: "/en/whisky-catalogue-old",
    component: _af77a86e,
    name: "whisky-catalogue-old___en"
  }, {
    path: "/en/workshops-and-webinars",
    component: _42599966,
    name: "workshops-and-webinars___en"
  }, {
    path: "/nl/account",
    component: _cbd4fa14,
    name: "account___nl"
  }, {
    path: "/nl/algemene-voorwaarden",
    component: _811604b0,
    name: "terms-conditions___nl"
  }, {
    path: "/nl/artikelen",
    component: _1c4468ea,
    name: "articles___nl"
  }, {
    path: "/nl/bevestig-email",
    component: _5e344f55,
    name: "confirm-email___nl"
  }, {
    path: "/nl/claim-anchored-bottles",
    component: _5fe77fe2,
    name: "claim-anchored-bottles___nl"
  }, {
    path: "/nl/grafieken",
    component: _b2d66cfc,
    name: "charts___nl"
  }, {
    path: "/nl/inloggen",
    component: _10ba8d22,
    name: "login___nl"
  }, {
    path: "/nl/investor-portfolio",
    component: _0c3cbe3d,
    name: "investor-portfolio___nl"
  }, {
    path: "/nl/lessen",
    component: _64868cf8,
    name: "lessons___nl"
  }, {
    path: "/nl/order-bevestiging",
    component: _59bdffc1,
    name: "order-confirmation___nl"
  }, {
    path: "/nl/orders",
    component: _d4beb662,
    children: [{
      path: "columns",
      component: _56a5075c,
      name: "orders-columns___nl"
    }, {
      path: "filters",
      component: _14cad918,
      name: "orders-filters___nl"
    }, {
      path: "/nl/orders",
      component: _358c1412,
      name: "orders___nl"
    }]
  }, {
    path: "/nl/portfolio",
    component: _7813be64,
    children: [{
      path: "",
      component: _4023565e,
      name: "portfolio___nl"
    }, {
      path: "bids/columns",
      component: _7612c6ba,
      name: "portfolio-bids-columns___nl"
    }, {
      path: "claimed/columns",
      component: _b5e941b2,
      name: "portfolio-claimed-columns___nl"
    }, {
      path: "current/columns",
      component: _6d31e8c9,
      name: "portfolio-current-columns___nl"
    }, {
      path: "current/filters",
      component: _e3c2002a,
      name: "portfolio-current-filters___nl"
    }, {
      path: "onboarded/columns",
      component: _83b592c8,
      name: "portfolio-onboarded-columns___nl"
    }, {
      path: "sold/columns",
      component: _8cf1db88,
      name: "portfolio-sold-columns___nl"
    }, {
      path: "/nl/portefeuille/biedingen",
      component: _92c046ac,
      name: "portfolio-bids___nl"
    }, {
      path: "/nl/portefeuille/huidig",
      component: _61c6868a,
      name: "portfolio-current___nl"
    }, {
      path: "/nl/portefeuille/ingebracht",
      component: _af222ef0,
      name: "portfolio-onboarded___nl"
    }, {
      path: "/nl/portefeuille/verkocht",
      component: _5cd9ce30,
      name: "portfolio-sold___nl"
    }, {
      path: "/nl/portefeuille/verzonden",
      component: _4da7fac6,
      name: "portfolio-claimed___nl"
    }]
  }, {
    path: "/nl/registratie",
    component: _41d65b66,
    name: "registration___nl"
  }, {
    path: "/nl/saldo",
    component: _629398e5,
    name: "balance___nl"
  }, {
    path: "/nl/selecteer-portefeuille",
    component: _2b00fc21,
    name: "select-portfolio___nl"
  }, {
    path: "/nl/signin-callback",
    component: _f6ff91d4,
    name: "signin-callback___nl"
  }, {
    path: "/nl/whisky-catalogus",
    component: _20f4496f,
    name: "whisky-catalogue___nl",
    children: [{
      path: "/nl/whisky-catalogus/:slug",
      component: _42c31f6a,
      name: "whisky-catalogue-slug___nl"
    }]
  }, {
    path: "/nl/whisky-catalogus-old",
    component: _af77a86e,
    name: "whisky-catalogue-old___nl"
  }, {
    path: "/nl/workshops-en-webinars",
    component: _42599966,
    name: "workshops-and-webinars___nl"
  }, {
    path: "/nl/zoeken",
    component: _6cfe81d6,
    name: "search___nl"
  }, {
    path: "/registration/confirm-your-email",
    component: _f6eca36a,
    name: "registration-confirm-your-email"
  }, {
    path: "/registration/finish",
    component: _13afa42f,
    name: "registration-finish"
  }, {
    path: "/registration/start",
    component: _19e4a214,
    children: [{
      path: "",
      component: _1a9ca4f9,
      name: "registration-start"
    }, {
      path: "address",
      component: _fa5f614a,
      name: "registration-start-address"
    }, {
      path: "confirm-email",
      component: _4e71acf6,
      name: "registration-start-confirm-email"
    }, {
      path: "personal-info",
      component: _a2140e7c,
      name: "registration-start-personal-info"
    }]
  }, {
    path: "/account/claim-list/confirmation",
    component: _5724174e,
    name: "account-claim-list-confirmation"
  }, {
    path: "/account/claim-list/index",
    component: _0ff7a7e1,
    name: "account-claim-list-index"
  }, {
    path: "/account/documents/columns",
    component: _7a9136b6,
    name: "account-documents-columns"
  }, {
    path: "/en/account/claim-list",
    component: _0ff7a7e1,
    name: "account-claim-list-index___en"
  }, {
    path: "/en/account/documents",
    component: _7f4a555f,
    name: "account-documents___en"
  }, {
    path: "/en/account/personal",
    component: _47948b62,
    name: "account-personal___en"
  }, {
    path: "/en/balance/columns",
    component: _489691df,
    name: "balance-columns___en"
  }, {
    path: "/en/balance/filters",
    component: _6983a901,
    name: "balance-filters___en"
  }, {
    path: "/en/category/columns",
    component: _24354519,
    name: "category-columns___en"
  }, {
    path: "/en/category/filters",
    component: _45225c3b,
    name: "category-filters___en"
  }, {
    path: "/en/category/sorting",
    component: _c7575bdc,
    name: "category-sorting___en"
  }, {
    path: "/en/registration/confirm-your-email",
    component: _f6eca36a,
    name: "registration-confirm-your-email___en"
  }, {
    path: "/en/registration/finish",
    component: _13afa42f,
    name: "registration-finish___en"
  }, {
    path: "/en/registration/start",
    component: _19e4a214,
    children: [{
      path: "",
      component: _1a9ca4f9,
      name: "registration-start"
    }, {
      path: "address",
      component: _fa5f614a,
      name: "registration-start-address"
    }, {
      path: "confirm-email",
      component: _4e71acf6,
      name: "registration-start-confirm-email"
    }, {
      path: "personal-info",
      component: _a2140e7c,
      name: "registration-start-personal-info"
    }, {
      path: "/en/registration/start",
      component: _1a9ca4f9,
      name: "registration-start___en"
    }, {
      path: "/en/registration/start/address",
      component: _fa5f614a,
      name: "registration-start-address___en"
    }, {
      path: "/en/registration/start/confirm-email",
      component: _4e71acf6,
      name: "registration-start-confirm-email___en"
    }, {
      path: "/en/registration/start/personal-info",
      component: _a2140e7c,
      name: "registration-start-personal-info___en"
    }]
  }, {
    path: "/nl/account/documenten",
    component: _7f4a555f,
    name: "account-documents___nl"
  }, {
    path: "/nl/account/persoonlijk",
    component: _47948b62,
    name: "account-personal___nl"
  }, {
    path: "/nl/account/verzend-lijst",
    component: _0ff7a7e1,
    name: "account-claim-list-index___nl"
  }, {
    path: "/nl/balance/columns",
    component: _489691df,
    name: "balance-columns___nl"
  }, {
    path: "/nl/balance/filters",
    component: _6983a901,
    name: "balance-filters___nl"
  }, {
    path: "/nl/category/columns",
    component: _24354519,
    name: "category-columns___nl"
  }, {
    path: "/nl/category/filters",
    component: _45225c3b,
    name: "category-filters___nl"
  }, {
    path: "/nl/category/sorting",
    component: _c7575bdc,
    name: "category-sorting___nl"
  }, {
    path: "/nl/registratie/bevestig-je-email",
    component: _f6eca36a,
    name: "registration-confirm-your-email___nl"
  }, {
    path: "/nl/registratie/einde",
    component: _13afa42f,
    name: "registration-finish___nl"
  }, {
    path: "/nl/registration/start",
    component: _19e4a214,
    children: [{
      path: "/nl/registratie/start",
      component: _1a9ca4f9,
      name: "registration-start___nl"
    }, {
      path: "/nl/registratie/start/address",
      component: _fa5f614a,
      name: "registration-start-address___nl"
    }, {
      path: "/nl/registratie/start/bevestig-email",
      component: _4e71acf6,
      name: "registration-start-confirm-email___nl"
    }, {
      path: "/nl/registratie/start/persoonlijke-informatie",
      component: _a2140e7c,
      name: "registration-start-personal-info___nl"
    }]
  }, {
    path: "/account/claim-list/index/columns",
    component: _47b46263,
    name: "account-claim-list-index-columns"
  }, {
    path: "/account/claim-list/index/filters",
    component: _68a17985,
    name: "account-claim-list-index-filters"
  }, {
    path: "/en/account/claim-list/confirmation",
    component: _5724174e,
    name: "account-claim-list-confirmation___en"
  }, {
    path: "/en/account/documents/columns",
    component: _7a9136b6,
    name: "account-documents-columns___en"
  }, {
    path: "/nl/account/documents/columns",
    component: _7a9136b6,
    name: "account-documents-columns___nl"
  }, {
    path: "/nl/account/verzend-lijst/bevestiging",
    component: _5724174e,
    name: "account-claim-list-confirmation___nl"
  }, {
    path: "/en/account/claim-list/index/columns",
    component: _47b46263,
    name: "account-claim-list-index-columns___en"
  }, {
    path: "/en/account/claim-list/index/filters",
    component: _68a17985,
    name: "account-claim-list-index-filters___en"
  }, {
    path: "/nl/account/claim-list/index/columns",
    component: _47b46263,
    name: "account-claim-list-index-columns___nl"
  }, {
    path: "/nl/account/claim-list/index/filters",
    component: _68a17985,
    name: "account-claim-list-index-filters___nl"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/en/account/documents/:slug",
    component: _7d93b417,
    name: "account-documents-slug___en"
  }, {
    path: "/en/whisky/basket/:slug?",
    component: _1b1b066d,
    name: "whisky-basket-slug___en"
  }, {
    path: "/nl/account/documenten/:slug",
    component: _7d93b417,
    name: "account-documents-slug___nl"
  }, {
    path: "/nl/whisky/basket/:slug?",
    component: _1b1b066d,
    name: "whisky-basket-slug___nl"
  }, {
    path: "/account/documents/:slug",
    component: _7d93b417,
    name: "account-documents-slug"
  }, {
    path: "/en/articles/:slug",
    component: _1a8dc7a2,
    name: "articles-slug___en"
  }, {
    path: "/en/category/:slug",
    component: _155df523,
    name: "category-slug___en"
  }, {
    path: "/en/lessons/:slug",
    component: _67f3cf88,
    name: "lessons-slug___en"
  }, {
    path: "/en/whisky/:slug",
    component: _d0c7f55e,
    name: "whisky-slug___en"
  }, {
    path: "/en/workshops-and-webinars/:slug",
    component: _45c6dbf6,
    name: "workshops-and-webinars-slug___en"
  }, {
    path: "/nl/artikelen/:slug",
    component: _1a8dc7a2,
    name: "articles-slug___nl"
  }, {
    path: "/nl/categorie/:slug",
    component: _155df523,
    name: "category-slug___nl"
  }, {
    path: "/nl/lessen/:slug",
    component: _67f3cf88,
    name: "lessons-slug___nl"
  }, {
    path: "/nl/whisky/:slug",
    component: _d0c7f55e,
    name: "whisky-slug___nl"
  }, {
    path: "/nl/workshops-en-webinars/:slug",
    component: _45c6dbf6,
    name: "workshops-and-webinars-slug___nl"
  }, {
    path: "/whisky/basket/:slug?",
    component: _1b1b066d,
    name: "whisky-basket-slug"
  }, {
    path: "/en/whisky/:slug/transactions",
    component: _3fa852ae,
    name: "whisky-slug-transactions___en"
  }, {
    path: "/nl/whisky/:slug/transacties",
    component: _3fa852ae,
    name: "whisky-slug-transactions___nl"
  }, {
    path: "/en/whisky/:slug?/transactions/columns",
    component: _7e060c9b,
    name: "whisky-slug-transactions-columns___en"
  }, {
    path: "/nl/whisky/:slug?/transactions/columns",
    component: _7e060c9b,
    name: "whisky-slug-transactions-columns___nl"
  }, {
    path: "/articles/:slug",
    component: _1a8dc7a2,
    name: "articles-slug"
  }, {
    path: "/category/:slug?",
    component: _155df523,
    name: "category-slug"
  }, {
    path: "/en/:slug",
    component: _f6ee20da,
    name: "slug___en"
  }, {
    path: "/lessons/:slug",
    component: _67f3cf88,
    name: "lessons-slug"
  }, {
    path: "/nl/:slug",
    component: _f6ee20da,
    name: "slug___nl"
  }, {
    path: "/whisky/:slug",
    component: _d0c7f55e,
    name: "whisky-slug"
  }, {
    path: "/workshops-and-webinars/:slug?",
    component: _45c6dbf6,
    name: "workshops-and-webinars-slug"
  }, {
    path: "/whisky/:slug?/transactions",
    component: _3fa852ae,
    name: "whisky-slug-transactions"
  }, {
    path: "/whisky/:slug?/transactions/columns",
    component: _7e060c9b,
    name: "whisky-slug-transactions-columns"
  }, {
    path: "/en/:slug/:seoArticleSlug",
    component: _1374b544,
    name: "slug-seoArticleSlug___en"
  }, {
    path: "/nl/:slug/:seoArticleSlug",
    component: _1374b544,
    name: "slug-seoArticleSlug___nl"
  }, {
    path: "/:slug",
    component: _f6ee20da,
    name: "slug"
  }, {
    path: "/:slug/:seoArticleSlug",
    component: _1374b544,
    name: "slug-seoArticleSlug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
